import { colorsFor } from '@/app/theme/appColors';
import { PixelLoadingDots } from '@/ui/pixel/PixelLoadingDots';

/// Boot splash: title + three sequential square dots.

export function AppLoadingScreen({ isDark }: { isDark: boolean }) {
  const surface = isDark ? colorsFor(true).surface : colorsFor(false).surface;
  const onSurface = isDark ? colorsFor(true).onSurface : colorsFor(false).onSurface;

  return (
    <div className="flex h-full items-center justify-center" style={{ backgroundColor: surface }}>
      <div className="flex flex-col items-center">
        <span className="leading-none" style={{ fontSize: 52, color: onSurface }}>
          Dino Dash
        </span>
        <div className="mt-7">
          <PixelLoadingDots color={onSurface} />
        </div>
      </div>
    </div>
  );
}
